import { FolderInput } from '@/shared/ui/icons';
import { HeaderActionPill } from './headerActions/HeaderPillPrimitives';
import type { MobileHeaderAction } from './headerActions/types';

/**
 * Header action shown on BOQ pricing while one or more rows are selected.
 * It uses the shared header primitive so its size, colour, interaction states
 * and menu match every neighbouring toolbar action.
 */
export interface BOQMoveSelectionPillProps {
  selectedCount: number;
  bills: Array<{ id: string; label: string }>;
}

export function BOQMoveSelectionPill({ selectedCount, bills }: BOQMoveSelectionPillProps) {
  const moveLabel = `Move ${selectedCount} selected item${selectedCount === 1 ? '' : 's'} to another bill`;
  const action = {
    id: 'boq-move-selection',
    icon: FolderInput,
    ariaLabel: moveLabel,
    group: 'page',
    subActions: bills.length > 0
      ? bills.map((bill) => ({
          id: `boq-move-to-${bill.id}`,
          label: bill.label,
          onClick: () => {
            window.dispatchEvent(
              new CustomEvent('boq:move-to-bill', { detail: { targetBillId: bill.id } }),
            );
          },
        }))
      : [{
          id: 'boq-move-no-bills',
          label: 'No other bills available',
          disabled: true,
          onClick: () => undefined,
        }],
  } satisfies MobileHeaderAction;

  return <HeaderActionPill action={action} />;
}
